import * as React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import DataTable from '../DataTable';
import { INotificationTemplate } from './business-objects/common';
import {
  getAllTemplates,
  saveNewNotifications,
  saveUpdatedNotificationTemplate,
} from './redux-objects/actions';
import { Modal, Button } from 'react-bootstrap';
import TemplateEditForm from './TemplateEditForm';
import { GetURIByParts } from '../../services/Utils/StringUtils';
import './assets/templatelist.css';
import { MultiSelectOption } from '../MultiSelect/common';

interface INotificationTemplatesActionProps {
  getAllTemplates: (url: string) => void;
  saveUpdatedNotificationTemplate: (
    url: string,
    notification: INotificationTemplate
  ) => void;
  saveNewNotifications: (
    url: string,
    notification: INotificationTemplate
  ) => void;
}

interface INotificationTemplatesStateProps {
  notificationTemplates: INotificationTemplate[];
  webServiceURL: string;
  isProcessing: boolean;
}

interface INotificationTemplatesProps
  extends INotificationTemplatesActionProps,
    INotificationTemplatesStateProps {}

interface INotificationTemplatesState {
  userOnlyFiler: boolean;
  activeFilter: boolean;
  showModal: boolean;
  modalStatus: ModalMode;
  currentTemplate: INotificationTemplate;
  selectedTemplateOptions: MultiSelectOption[];
}

enum ModalMode {
  None,
  New,
  Editing,
}

enum ServiceEndPoints {
  AllActiveNotifications = 'Active',
  PostTemplate = 'PostTemplate',
  PutTemplate = 'PutTemplate',
}

class NotificationTemplates extends React.Component<
  INotificationTemplatesProps,
  INotificationTemplatesState
> {
  private editForm: any = React.createRef();

  state = {
    userOnlyFiler: true,
    activeFilter: true,
    showModal: false,
    modalStatus: ModalMode.None,
    currentTemplate: null,
    selectedTemplateOptions: [],
  };

  private notificationTemplatesServiceController: string =
    'NotificationTemplate';

  componentWillMount() {
    let uri = GetURIByParts(
      this.props.webServiceURL,
      this.notificationTemplatesServiceController,
      ServiceEndPoints.AllActiveNotifications
    );

    let params = {
      userOnly: this.state.userOnlyFiler,
      active: true,
    };

    let esc = encodeURIComponent;
    let query = Object.keys(params)
      .map((k) => esc(k) + '=' + esc(params[k]))
      .join('&');

    uri = uri + '?' + query;

    this.props.getAllTemplates(uri);
  }

  editTemplate = (e) => {
    let currTemplate: INotificationTemplate = this.props.notificationTemplates.find(
      (notification) =>
        notification.id.toString() ==
        ((e as Event).currentTarget as HTMLButtonElement).value
    );
    this.toggleScrollLock();
    this.setState({
      modalStatus: ModalMode.Editing,
      showModal: true,
      currentTemplate: currTemplate,
    });
  };

  createNewTemplate = (e) => {
    this.toggleScrollLock();
    this.setState({
      modalStatus: ModalMode.New,
      showModal: true,
      currentTemplate: null,
      selectedTemplateOptions: [],
    });
  };

  setCustomAvail = (e) => {
    this.setState({
      modalStatus: ModalMode.Editing,
      showModal: true,
      currentTemplate: this.props.notificationTemplates.filter(
        (x) => x.id == -1
      )[0],
    });
  };
  closeModel = (e?) => {
    this.toggleScrollLock();
    this.setState({
      modalStatus: ModalMode.None,
      showModal: false,
      currentTemplate: null,
    });
  };

  toggleScrollLock = () => {
    //document.querySelector('html').classList.toggle('scroll-lock');
  };

  onSaveNotificationTemplate = async (e) => {
    let updatedTemplate: INotificationTemplate = this.editForm.getUpdatedTemplate();
    updatedTemplate.active = true;
    updatedTemplate.id != null
      ? await this.props.saveUpdatedNotificationTemplate(
          GetURIByParts(
            this.props.webServiceURL,
            this.notificationTemplatesServiceController,
            ServiceEndPoints.PutTemplate
          ),
          updatedTemplate
        )
      : await this.props.saveNewNotifications(
          GetURIByParts(
            this.props.webServiceURL,
            this.notificationTemplatesServiceController,
            ServiceEndPoints.PostTemplate
          ),
          updatedTemplate
        );
    this.closeModel();
    this.componentWillMount();

    // @ts-ignore
    DataTable().reload();
    this.forceUpdate()
  };

  // handleOptionSelect = (selectedItem: MultiSelectOption) => {
  //   this.setState(prevState => ({
  //     currentTemplate: {
  //     ...prevState.currentTemplate,
  //     selectedTemplateOptions: [...prevState.currentTemplate.selectedTemplateOptions, selectedItem]
  //   }
  //   }));

  //   return true;
  // };

  // handleOptionRemove = (selectedItem: MultiSelectOption) => {
  //   this.setState(prevState => ({
  //     currentTemplate: {
  //     ...prevState.currentTemplate,
  //     selectedTemplateOptions: [
  //       ...prevState.selectedTemplateOptions.filter(
  //         option => option.id !== selectedItem.id
  //       )]
  //     }
  //   }));
  //   return true
  // };

  render() {
    const columnDefs = [
      {
        targets: 5,
        render: (data: moment.MomentInput) =>
          moment(data).format('MMMM Do YYYY'),
      },
      {
        targets: 0,
        createdCell: (td, cellData, rowData, row, col) => {
          return ReactDOM.render(
            <button
              className={'btn btn-outline-warning'}
              value={cellData}
              data-id={cellData}
              onClick={this.editTemplate}
            >
              Edit Template
            </button>,
            td
          );
        },
      },
    ];

    const columns = [
      {
        title: 'Edit Template',
        data: 'id',
      },
      {
        title: 'Id',
        data: 'id',
      },
      {
        title: 'Subject',
        data: 'subject',
      },
      {
        title: 'Description',
        data: 'description',
      },
      {
        title: 'Body',
        data: 'body',
      },
      {
        title: 'Created Date',
        data: 'createdDate',
      },
    ];

    const options = {
      className: 'table table-striped table-bordered',
    };

    return (
      <div id='divTemplateList'>
        <h3>Letter Templates</h3>
        <a href='#' onClick={this.createNewTemplate}>
          Create New Template
        </a>
        <a href='#' onClick={this.setCustomAvail} className='pull-right'>
          Set Custom Availability
        </a>
        <DataTable
          id='tblNotificationTemplates'
          data={this.props.notificationTemplates.filter((x) => x.id > 0)}
          columns={columns}
          {...options}
          columnDefs={columnDefs}
        />
        <Modal
          show={this.state.showModal}
          onHide={this.closeModel}
          dialogClassName='modal-notification-template-edit'
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {' '}
              {this.state.modalStatus == ModalMode.New
                ? 'Create Letter Template'
                : this.state.currentTemplate &&
                  this.state.currentTemplate.id > 0
                ? 'Edit Letter Template'
                : 'Custom Template Availability'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <TemplateEditForm
              templateToEdit={this.state.currentTemplate}
              ref={(ef) => (this.editForm = ef)}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={this.closeModel}>
              Close
            </Button>
            <Button variant='primary' onClick={this.onSaveNotificationTemplate}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (reduxState: any) => {
  return {
    notificationTemplates: reduxState.NotificationTemplates.allNotifications,
    webServiceURL: reduxState.Application.backendURL,
    isProcessing: reduxState.NotificationTemplates.isProcessing,
  };
};

const mapDispatchToProps = {
  getAllTemplates,
  saveNewNotifications,
  saveUpdatedNotificationTemplate,
};

export default connect<
  INotificationTemplatesStateProps,
  INotificationTemplatesActionProps
>(
  mapStateToProps,
  mapDispatchToProps
)(NotificationTemplates);
